import { EntityErrorBanner } from '@pesto/features/src/EntityProfile/components/EntityErrorBanner';
import { CreditUtilization } from '@pesto/features/src/UserProfile/components/CreditUtilization';
import { LoanDetails } from '@pesto/features/src/UserProfile/components/LoanDetails';

import type { LoanDetailViewModel } from '../toLoanDetail';

import { useGetCreditUtilizationQuery } from '../../../__generated__/graphql/api';

interface LoanOverviewTabProps {
  loan: LoanDetailViewModel;
}

export const LoanOverviewTab = ({ loan }: LoanOverviewTabProps) => {
  const {
    data: creditData,
    loading: creditLoading,
    error: creditError,
  } = useGetCreditUtilizationQuery({ variables: { loanId: loan.id }, skip: !loan.id });

  const credit = creditData?.creditUtilization;

  return (
    <div className="space-y-4">
      {creditError && <EntityErrorBanner message="Couldn't load credit utilization." detail={creditError.message} />}
      <div className="grid gap-4 lg:grid-cols-2">
        <CreditUtilization
          limit={credit?.limit ?? ''}
          balance={credit?.balance ?? ''}
          availableAmount={credit?.availableAmount ?? ''}
          spent={credit?.spent ?? ''}
          remaining={credit?.remaining ?? ''}
          loading={creditLoading}
          isDelinquent={loan.isDelinquent}
          daysDelinquent={loan.daysDelinquent}
          delinquentSince={loan.delinquentSince}
        />
        <LoanDetails
          originationDate={loan.originationDate}
          onboardedDate={loan.insertedAt}
          initialBalance={loan.initialBalance}
          aprMargin={loan.aprMargin}
          currentApr={loan.currentApr}
          currentPrimeRate={loan.currentPrimeRate}
          isVariableApr={loan.isVariableApr}
          promoEndDate={loan.promoEndDate}
          gracePeriodDays={loan.gracePeriodDays}
        />
      </div>
    </div>
  );
};
